import PadraoModel from 'src/core/model/PadraoModel.js'

export default class OlxAcessorioModel extends PadraoModel {
  recurso = 'olx/acessorios';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Acessórios Olx';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
